import { getFeatures } from '@infuse/api/feature';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import { defineStore } from 'pinia';
import { Feature } from './model';

dayjs.extend(duration);

interface State {
  items: string[];
  loading: boolean;
}

export const useFeatureStore = defineStore('features', {
  state: () => {
    return {
      items: [],
      loading: false
    } as State;
  },
  actions: {
    async getAll() {
      this.loading = true;

      this.items = (await getFeatures()) || [];

      this.loading = false;
    },

    hasFeature(feature: Feature): boolean {
      return this.items.includes(feature);
    }
  }
});
